import React from "react";
import { Card, CardContent, Typography, CardMedia, Grid, } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';

const PlataformasExternas = ({ image, title, subtitle, link, isSvg }) => {
	const StyleCard = withStyles(() => ({
    root: {
			display: "flex",
			boxShadow: "none",
			borderRadius: '8px',
      "&:hover": {
        cursor: "pointer"
      }
    }
  }))(Card)

	return (
		<Grid item xs={12} sm={6}>
			<StyleCard
				onClick={() => window.open(link, '_self')}
			>
				<CardMedia
					component={isSvg ? image : "img"}
					alt={title}
					style={{
						width: "72.32px",
						height: "99.54px",
						borderRadius: "8px 2px 2px 2px",
						margin: 0,
					}}
					image={!isSvg && image}
				/>
				<CardContent>
					<Typography variant="h5" component="div" style={{ fontFamily: 'Inter', fontWeight: '700', fontSize: '20px', lineHeight: '28px' }}>
						{title}
					</Typography>
					<Typography variant="subtitle1" color="textSecondary" style={{ fontFamily: 'Inter', fontWeight: '500', fontSize: '12px', lineHeight: '16px', color: '#646464' }}>
						{subtitle}
					</Typography>
				</CardContent>
			</StyleCard>
		</Grid>
	);
};

export default PlataformasExternas;
